import {z} from 'zod';

import {officeInformationSchema} from '../../EmmaiDentalOfficeForm/helpers/schema';
import {formSchema as practitionerActivitySchema} from '../../EmmaiPractitionerActivityInformationForm/helpers/schema';

export const parentFormSchema = z.object({
  officeInformation: officeInformationSchema,
  practitionerActivity: practitionerActivitySchema
});
